import React from "react";
import { useUserAuth } from "../../../contexts/UserAuthContext";
import { useToast } from "../../../contexts/ToastContext";
import { useActivityQuery } from "../../../hooks/profile/queries";
import ActivityView from "../../../components/profile/views/ActivityView";

/**
 * ActivityPage - User's activity history
 */
const ActivityPage = () => {
  const { user } = useUserAuth();
  const { showToast } = useToast();
  const userId = user?.id || user?._id;

  const { data: activities = [], isLoading, error, refetch } = useActivityQuery(userId);

  return (
    <ActivityView
      activities={activities}
      loading={isLoading}
      error={error?.message}
      onRefresh={refetch}
      showToast={showToast}
      currentTab="activity"
    />
  );
};

export default ActivityPage;
